import React from "react";
import Director from "../Director";
import Guiding from "../Guiding";
import Abouthead from "../Abouthead";

const About = () => {
  return (
    <div>
      <Abouthead />
      <Guiding />
      <Director />
    </div>
  );
};

export default About;
